import { Box, Chip, Typography, useTheme } from '@mui/material';
import { tokens } from '../../../global/theme/tokens';

/**
 * A titled divider between groups of fields, with an optional badge for the
 * amount that group contributes. Lets a long form be skimmed and ignored
 * section by section.
 */
const TypeSectionHeader = ({ field }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  return (
    <Box
      sx={{
        gridColumn: field.colspan
          ? `span ${field.colspan} / span ${field.colspan}`
          : 'auto',
      }}
      className="flex items-center gap-3 w-full pt-2"
    >
      <Typography variant="h6" className="whitespace-nowrap">
        {field.label}
      </Typography>

      {field.badge != null && (
        <Chip size="small" label={field.badge} sx={{ bgcolor: colors.bgInput }} />
      )}

      <Box
        className="rounded-full grow"
        sx={{ backgroundColor: colors.text, height: '2px', opacity: 0.2 }}
      />

      {field.info && (
        <Typography variant="body2" className="opacity-60 whitespace-nowrap">
          {field.info}
        </Typography>
      )}
    </Box>
  );
};

export default TypeSectionHeader;
